import React, { FC, memo } from 'react';
import { Input } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    value?: {
        value?: string;
    };
    onChange?: (value: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    const onValueChange = (v: any) => {
        onChange?.({
            value: v,
        });
    };

    return (
        <Input
            value={value?.value}
            onChange={(e) => onValueChange(e.target.value)}
            style={{ width: 150 }}
            placeholder={/* 请输入路径表达式 */UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.components.valuePlain.index.pleaseEnterAPathExpression}
        />
    );
});

export default Template;
